export default {
  accentColor: '#1B1C1D',
  floatingNav: {
    background: '#333',
    chevron: '#FFF',
    color: '#FFF',
  },
  headerColor: '#1B1C1D',
  selectionColor: '#1B1C1D',
  textColor: {
    active: '#FFF',
    default: '#333',
  },
  todayColor: '#666',
  weekdayColor: '#1B1C1D',
}



// WEBPACK FOOTER //
// ./src/components/CalendarModal/theme.js